import { useQuery } from '@tanstack/react-query';

import { fetchClientAuditLogs, type AuditActionType } from '../lib/clients-api';

export const clientAuditLogsKeys = {
  all: (clientId: string) => ['client-audit-logs', clientId] as const,
  filtered: (clientId: string, action?: AuditActionType) =>
    [...clientAuditLogsKeys.all(clientId), { action }] as const,
};

export function useClientAuditLogs(clientId: string | undefined, action?: AuditActionType) {
  return useQuery({
    queryKey: clientAuditLogsKeys.filtered(clientId ?? '', action),
    queryFn: () => fetchClientAuditLogs(clientId as string, { action, limit: 50 }),
    enabled: Boolean(clientId),
    staleTime: 30_000,
  });
}
